import { DataTableSkeleton } from '@Components/General/Skeletons';
import { createFileRoute, defer } from '@tanstack/react-router';
import {
    contactFiltersQueryOptions,
    contactsMobileQueryOptions,
    contactsQueryOptions,
} from '@utils/queryOptions';
import { pageParamMiddleware } from '@utils/routeUtils';
import Contacts from '@Views/Contacts/Contacts';
import MobileContacts from '@Views/Contacts/Contacts/MobileContacts';

export const Route = createFileRoute('/contacts/')({
    component: Contacts,
    // component: MobileContacts,
    loader: opts => {
        opts.context.queryClient.ensureQueryData(
            contactsQueryOptions(opts.deps),
        );
        // opts.context.queryClient.ensureInfiniteQueryData(
        //     contactsMobileQueryOptions(opts.deps),
        // );
        defer(
            opts.context.queryClient.ensureQueryData(
                contactFiltersQueryOptions(),
            ),
        );
    },
    loaderDeps: ({ search }) => search,
    pendingComponent: DataTableSkeleton,
    search: { middlewares: [pageParamMiddleware] },
});
